import dayjs from "dayjs"
import { mySqlToLocal } from "@helpers"
import isBetween from "dayjs/plugin/isBetween"

dayjs.extend(isBetween)

const getDateRangeStatus = (starts, ends, precision = "day") => {
  if (starts === null || ends === null) return "Setup"

  const startDate = mySqlToLocal(starts)
  const endDate = mySqlToLocal(ends)
  const today = dayjs()

  if (today.isBetween(startDate, endDate, precision, "[]")) return "Current"

  if (today.isBefore(startDate, precision)) return "Upcoming"

  if (today.isAfter(endDate, precision)) return "Expired"
}

export default getDateRangeStatus
